import { FC } from "react";
import { Filter } from "react-admin";

import SearchWithQuery from "../../../../components/CustomSearch/SearchWithQuery";
import { clientsCollRef } from "../../../../utils/referencies";

const ClientsFilters: FC<any> = (props) => {
  return (
    <Filter {...props}>
      <SearchWithQuery query={clientsCollRef} source="displayName" label="Name" />
    </Filter>
  );
};

export default ClientsFilters;
